import * as Sentry from "@sentry/browser";

import {
  EXTENSION_SCRIPT,
  FOREIGN_MESSAGE,
  OWN_SCRIPT,
  POSTHOG_CHUNK,
} from "@/lib/error-filters";

/** Until this runs, Sentry's capture calls are no-ops, so callers never need to check. */
export function initSentry(): void {
  Sentry.init({
    dsn: "https://6ca381aee5d52071bafe31c137eb3ea8@o4509365835857920.ingest.de.sentry.io/4509400367890512",
    // Sentry v11 replaced `sendDefaultPii` with `dataCollection`, whose defaults
    // already collect user info, IP, headers and cookies.
    environment: import.meta.env.MODE,
    ignoreErrors: [/posthog/i, FOREIGN_MESSAGE],
    // Checked against the file the error was thrown from.
    allowUrls: [OWN_SCRIPT],
    denyUrls: [POSTHOG_CHUNK, EXTENSION_SCRIPT],
    beforeSend(event) {
      // A blocker (ad/tracking extension) stopping PostHog's requests surfaces
      // as a network error without a stack: drop it when PostHog's request is
      // the one that just failed.
      const lastRequest = (event.breadcrumbs ?? [])
        .filter((b) => b.category === "fetch" || b.category === "xhr")
        .pop();
      const requestUrl = String(lastRequest?.data?.url ?? "");
      const isNetworkError = /Failed to fetch|Load failed|NetworkError/i.test(
        JSON.stringify(event.exception ?? event.message ?? "")
      );
      return isNetworkError && /posthog/i.test(requestUrl) ? null : event;
    },
  });
}
